import { convertEntities } from '@amzn/awscat-editor';
import { ContentMetadata } from '@amzn/awscat-pattern-library-service-model';
import React, { useContext } from 'react';
import { AppContext } from '../../contexts/AppContext';
import { Link } from '@amzn/awsui-components-core';
import { getContentPath } from '../../common/ContentPaths';

export interface Props {
  contentId: string;
  metadata: ContentMetadata;
}

const ContentViewerLink: React.FunctionComponent<Props> = (props: Props) => {
  const { contentId, metadata } = props;
  const appContext = useContext(AppContext);
  return (
    <Link
      variant="secondary"
      href={getContentPath({ contentId, mode: 'draft', role: 'read-only' })}
    >
      {convertEntities(metadata.contentName, appContext.entities)}
    </Link>
  );
};

export default ContentViewerLink;
